import { Button, Heading } from "@elaniintc/goes-design-system";
import { useNavigate } from "react-router";

interface Props {
  statusCode?: number;
  title: string;
  description: string;
  actionText?: string;
  actionLink?: string;
}

const StatusPage = ({
  title,
  description,
  statusCode,
  actionLink = "/",
  actionText = "Volver al inicio",
}: Props) => {
  const navigate = useNavigate();
  return (
    <div className="flex h-full w-full items-center justify-center">
      <div className="max-w-[456px] flex flex-col items-center gap-8">
        <div>
          {statusCode && (
            <Heading variant="h6" className="font-geist-mono text-center">
              {statusCode}
            </Heading>
          )}
          <Heading variant="h2" className="text-center">
            {title}
          </Heading>
          <p className="text-base leading-3xl text-body text-center pt-2">
            {description}
          </p>
        </div>
        <Button
          variant="quiet"
          className="w-full"
          onClick={() => navigate(actionLink)}
        >
          {actionText}
        </Button>
      </div>
    </div>
  );
};

export default StatusPage;
